// @ts-nocheck


import queryString from 'query-string';


import {
  fetchRequest,
  initialFetchListParams,
  downloadRequestWithToken } from
'./index';

import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { convertDataFromServer as actConvertDataFromServer } from './act';
import { convertDataFromServer as convertDataFromServerGroupedList } from './executionBudget';


export const convertDataFromServer = (platon) => ({
  ...platon,
  paymentAmount: convertFromKopToRub(platon.paymentAmount),
  act: platon.act ? actConvertDataFromServer(platon.act) : undefined
});

export const convertDataToServer = (platon) => ({
  ...platon,
  paymentAmount: convertFromRubToKop(platon.paymentAmount)
});

export const addPlaton = async (platon) => {
  const added = await fetchRequest.post('/platon', convertDataToServer(platon));
  if (added) return added;
  throw new Error('Не удалось создать Платон');
};

export const updatePlaton = async (platon) => {
  const updated = await fetchRequest.put(
    '/platon',
    convertDataToServer(platon)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить Платон');
};
export const deletePlaton = async (id) => {
  const deleted = await fetchRequest.delete(`/platon/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить Платон');
};

export const fetchPlaton = async (
id,
params = {}) =>
{
  const platon = await fetchRequest.get(`/platon/${id}`, params);
  if (platon) return convertDataFromServer(platon);
  throw new Error('Не удалось получить Платон');
};

export const fetchVehiclePlatons = async (
vehicleId,
params = initialFetchListParams) =>
{
  const platons = await fetchRequest.get(`/platon/vehicle/${vehicleId}`, {
    ...initialFetchListParams,
    ...params
  });
  if (platons) {
    return {
      ...platons,
      data: platons.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список Платонов');
};

export const fetchPlatons = async (
params = initialFetchListParams) =>
{
  const platon = await fetchRequest.get('/platon', {
    ...initialFetchListParams,
    ...params
  });
  if (platon) {
    return {
      ...platon,
      data: platon.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список Платонов');
};

export const updateAct = async (
params,
data) =>
{
  const platon = await fetchRequest.put(
    `/platon/updateActId?${queryString.stringify(params)}`,
    data
  );
  if (platon) {
    return {
      ...platon,
      data: platon.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось закрепить акт за списоком');
};

export const getTotalSum = async (params = {}) => {
  const sum = await fetchRequest.get(`/platon/totalSum`, params);
  if (sum || sum === 0) return convertFromKopToRub(sum);
  throw new Error('Не удалось получить общую сумму');
};

export const groupedList = async (
params = {}) =>
{
  const groupedList = await fetchRequest.get(`/platon/groupedList`, params);
  if (groupedList)
  return {
    ...groupedList,
    data: groupedList.data.map(convertDataFromServerGroupedList)
  };
  throw new Error(
    'Не удалось получить сгруппированный список для исполнения бюджета'
  );
};

export const printReport = async (
params,
fileName) =>
{
  const isPrinted = await downloadRequestWithToken(
    '/platon/print',
    params,
    fileName
  );
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};

export default {
  groupedList,
  getTotalSum,
  updateAct,
  addPlaton,
  updatePlaton,
  deletePlaton,
  fetchPlaton,
  fetchVehiclePlatons,
  fetchPlatons,
  printReport
};
